// DatasetGalleryPage.tsx
import React from 'react';
import { useParams } from 'react-router-dom';
import GalleryPageBase from '../../component/GalleryPageBase';
import { FilterOption } from '../../component/FilterBar';

interface DatasetGalleryPageProps {
  datasetId?: number; // Optional prop if dataset ID is passed directly
}

const DatasetGalleryPage: React.FC<DatasetGalleryPageProps> = ({ datasetId }) => {
  // Get datasetId from URL for path like /dataset/3
  // Note the singular 'dataset' in the parameter name to match your URL structure
  const { id } = useParams<{ id: string }>();
  const currentDatasetId = datasetId || parseInt(id || '0', 10);
  
  if (!currentDatasetId) {
    return <div className="error-message">No dataset ID provided</div>;
  }

  const datasetFilterOptions: FilterOption[] = [
    {
      name: "part_name",
      label: "Part Name",
      type: "select",
      options: [], // Will be populated from API
    },
    {
      name: "part_number",
      label: "Part Number",
      type: "select",
      options: [],
    },
    {
      name: "model",
      label: "Model",
      type: "select",
      options: [],
    },
    {
      name: "system_name",
      label: "System Name",
      multiple: true,
      type: "select",
      options: [],
    },
    {
      name: "time_range",
      label: "Time Range",
      type: "timerange",
    },
    // You can add dataset-specific filters here
  ];

  const galleryConfig = {
    imagesEndpoint: `/api/datasets/${currentDatasetId}/images`,
    filterOptionsEndpoint: `/api/datasets/${currentDatasetId}/filters`,
    cardClickPath: '/image-view',
    pageType: 'dataset-view' as const,
    datasetId: currentDatasetId,
    customFilterOptions: datasetFilterOptions,
    monolithic: false,
  };


  return (
    <GalleryPageBase {...galleryConfig} />
  );
};

export default DatasetGalleryPage;